import { render } from "./Main.vue?vue&type=template&id=306cce99&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=306cce99&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-306cce99"

export default script